import classie from "./vendor/classie";
import Instafeed from "instafeed.js";
import PhotoSwipe from "photoswipe";
import PhotoSwipeUI_Default from "photoswipe/dist/photoswipe-ui-default";
import "./vendor/jquery.instagramFeed.min";
window.PhotoSwipe = PhotoSwipe;

export const initVideo = () => {
  var videoPlayButton,
    videoWrapper = document.getElementsByClassName("video-wrapper")[0],
    video = document.getElementsByTagName("video")[0],
    videoMethods = {
      initVideoPlayButton: function () {
        if (videoWrapper.contains(video)) {
          this.formatVideoPlayButton();
          video.classList.add("has-media-controls-hidden");
          videoPlayButton = document.getElementsByClassName(
            "video-overlay-play-button"
          )[0];
          videoPlayButton.addEventListener("click", this.hideVideoPlayButton);
        }
      },

      formatVideoPlayButton: function () {
        const markup = `
                <span class="video-overlay-play-button">
                    <svg class="play-button" viewBox="0 0 96 96">
                    <defs>
                    <clipPath id="clip-path">
                        <rect width="96" height="96" fill="none"/>
                    </clipPath>
                    </defs>
                    <g id="Component" transform="translate(0)" clip-path="url(#clip-path)">
                    <circle id="Ellipse_554" data-name="Ellipse 554" cx="48" cy="48" r="48" fill="#fff"/>
                    <path id="Polygon_2" data-name="Polygon 2" d="M19.12,0l19.12,22.139H0Z" transform="translate(62.739 28.88) rotate(90)" fill="#293b44"/>
                    </g>
                </svg>	
                </span>`;
        videoWrapper.insertAdjacentHTML("beforeend", markup);
      },

      hideVideoPlayButton: function () {
        video.play();
        videoPlayButton.classList.add("is-hidden");
        video.classList.remove("has-media-controls-hidden");
        video.setAttribute("controls", "controls");
      },
    };

  videoMethods.initVideoPlayButton();
};

export const accordion = (function () {
  var $accordion = $(".js-accordion");
  var $accordion_header = $accordion.find(".js-accordion-header");
  var $accordion_item = $(".js-accordion-item");

  // default settings
  var settings = {
    // animation speed
    speed: 300,
    // close all other accordion items if true
    oneOpen: false,
  };

  return {
    // pass configurable object literal
    init: function ($settings) {
      $accordion_header.on("click", function () {
        accordion.toggle($(this));
      });

      $.extend(settings, $settings);

      // ensure only one accordion is active if oneOpen is true
      if (settings.oneOpen && $(".js-accordion-item.active").length > 1) {
        $(".js-accordion-item.active:not(:first)").removeClass("active");
      }

      // reveal the active accordion bodies
      $(".js-accordion-item.active").find("> .js-accordion-body").show();
    },
    toggle: function ($this) {
      if (
        settings.oneOpen &&
        $this[0] !=
          $this
            .closest(".js-accordion")
            .find("> .js-accordion-item.active > .js-accordion-header")[0]
      ) {
        $this
          .closest(".js-accordion")
          .find("> .js-accordion-item")
          .removeClass("active")
          .find(".js-accordion-body")
          .slideUp();
      }
      // show/hide the clicked accordion item
      $this.closest(".js-accordion-item").toggleClass("active");
      $this.next().stop().slideToggle(settings.speed);
    },
  };
})();

export const initVideoFooter = (current_video, custom_wrapper) => {
  "use strict";
  var bodyEl = document.body;

  if (custom_wrapper == "product") {
    var videoWrap = document.getElementById("custom-video-wrapper-product");
    var videoEl = videoWrap.querySelector("video");
    var closeCtrl = videoWrap.querySelector(".action--close");
  } else if (custom_wrapper == "flowers") {
    var videoWrap = document.getElementById("custom-video-wrapper-flowers");
    var videoEl = videoWrap.querySelector("video");
    var closeCtrl = videoWrap.querySelector(".action--close");
  } else if (custom_wrapper) {
    var videoWrap = document.getElementById("custom-video-wrapper");
    var videoEl = videoWrap.querySelector("video");
    var closeCtrl = videoWrap.querySelector(".action--close");
  } else {
    var videoWrap = current_video.querySelector(".video-wrap");
    var videoEl = videoWrap.querySelector("video");
    var closeCtrl = current_video.querySelector(".action--close");
  }

  var playCtrl = current_video.querySelector(".action--play");

  function init() {
    initEvents();
  }

  function initEvents() {
    playCtrl.addEventListener("click", play);
    closeCtrl.addEventListener("click", hide);
    videoEl.addEventListener("canplaythrough", allowPlay);
    videoEl.addEventListener("ended", hide);
  }

  function allowPlay() {
    classie.add(bodyEl, "video-loaded");
  }

  function play() {
    //	classie.add(body, 'nav-active');
    videoEl.currentTime = 0;
    classie.remove(videoWrap, "video-wrap--hide");
    classie.add(videoWrap, "video-wrap--show");
    setTimeout(function () {
      videoEl.play();
    }, 600);
  }

  function hide() {
    //	classie.remove(body, 'nav-active');
    classie.remove(videoWrap, "video-wrap--show");
    classie.add(videoWrap, "video-wrap--hide");
    videoEl.pause();
  }

  init();
};
export const initInstagram = () => {
  console.log("instagram run");

  fetch(
    "https://ig.instant-tokens.com/users/6e2f7939-456f-4daf-9b2e-a4008e6aedae/instagram/17841440722660762/token?userSecret=5n4fryt8bg8hem9rwif6h"
  )
    .then((resp) => resp.json())
    .then((data) => {
      var feed = new Instafeed({
        accessToken: data.Token,
        limit: 6,
        resolution: "low_resolution",
        template:
          '<div class="col-6 col-md-2 col-lg-2"><div><a class="ratio-columns" target="_blank" href="{{link}}"><img class="instafeed__img" title="{{caption}}" alt="{{caption}}" src="{{image}}" /></a></div></div>',
        orientation: "square",
      });
      feed.run();
    });
};

export const initTopbar = () => {
  let body,
    menu,
    menuItems,
    filterButton,
    activeFilter,
    menuTopbarButton,
    menuTopbar,
    activeMenu,
    filterList,
    searchButton,
    searchField,
    closeButton;
  const init = () => {
    body = document.querySelector("body");
    menu = document.querySelector(".menu-icon");
    menuItems = document.querySelectorAll(".header .nav__list-item");
    menuTopbarButton = document.querySelector(".js-menu-trigger");
    filterButton = document.querySelector(".js-filter-trigger");
    menuTopbar = document.querySelector(".js-dropdown");
    activeMenu = document.querySelector(".topbar__menulink.active");
    activeFilter = document.querySelector(".filter-list > li.active");
    filterList = document.querySelector(".filter-list");
    searchButton = document.querySelector(".header__side__search");
    closeButton = document.querySelector(".close-search");
    searchField = document.querySelector(".hidden-search");
    applyListeners();

    if (activeMenu) {
      changeTextButton(menuTopbarButton, activeMenu);
    }

    if (activeFilter) {
      changeTextButton(filterButton, activeFilter);
    }
  };

  const changeTextButton = (button, text) => {
    button.firstChild.data = text.firstChild.data;
  };

  const applyListeners = () => {
    menuItems.forEach((menuItem) => {
      menuItem.addEventListener("click", () => {
        classie.toggle(body, "nav-active");
        classie.toggle(menu, "active");
      });
    });

    menu.addEventListener("click", () => {
      classie.toggle(body, "nav-active");
      classie.toggle(menu, "active");
    });

    if (menuTopbarButton) {
      menuTopbarButton.addEventListener("click", () => {
        classie.toggle(menuTopbar, "open");
        classie.toggle(menuTopbarButton, "open");
      });
    }

    if (filterButton) {
      filterButton.addEventListener("click", () => {
        classie.toggle(filterList, "open");
        classie.toggle(filterButton, "open");
      });
    }
    searchButton.addEventListener("click", () => {
      classie.toggle(searchField, "open");
    });
    closeButton.addEventListener("click", () => {
      classie.toggle(searchField, "open");
    });
  };
  init();
};

export const initGalleryPhotoSwipe = () => {
  // Init empty gallery array
  var items = [];
  // Loop over gallery items and push it to the array
  $(".gallery")
    .find("figure")
    .each(function () {
      // let $img = $(this).find('img');
      // console.log($img.get(0).naturalWidth);
      // console.log($img.get(0).naturalHeight);
      var $link = $(this).find("a"),
        item = {
          src: $link.attr("href"),
          w: $link.data("width"),
          h: $link.data("height"),
        };
      items.push(item);
    });
  console.log(items);
  // Define click event on gallery item
  $("figure a").click(function (event) {
    event.preventDefault();
    // Define object and gallery options
    var $pswp = $(".pswp")[0],
      options = {
        zoomEl: false,
        shareEl: false,
        tapToToggleControls: false,
        index: $(this).data("index") - 1,
        bgOpacity: 0.85,
        showHideOpacity: true,
      };

    // Initialize PhotoSwipe
    var gallery = new PhotoSwipe($pswp, PhotoSwipeUI_Default, items, options);
    gallery.init();
  });
};

export const showHideElementsFilter = (value) => {
  var list = $(".js-accordion-item");

  if (value == "All") {
    $(".js-accordion-item")
      .addClass("active")
      .removeClass("filtered")
      .slideDown(0, "easeInOutCirc")
      .find(".js-accordion-body")
      .slideDown(0, "easeInOutSine");
    $(".accordions div[data-filter]").slideDown(0, "easeInOutSine");
    $(".accordion-body__title").show();
  } else {
    $(list).slideDown(0, "easeInOutSine");
    $(".js-accordion-item").removeClass("active").removeClass("filtered");
    $(".accordions div[data-filter]").slideUp(0, "easeInOutSine");
    $(".accordion-body__title").hide();
    $(".accordions div[data-filter]").each(function () {
      if ($(this).data("filter") === value) {
        $(this)
          .closest(".js-accordion-item")
          .addClass("active")
          .addClass("filtered")
          .find(".js-accordion-body")
          .slideDown(0, "easeInOutSine");
        $(this).slideDown(0, "easeInOutSine");
      }
    });
    $(".js-accordion-item").not(".filtered").slideUp(800, "easeInOutSine");
  }
};

export const initDatePicker = () => {
  $("#datetimepicker1").datetimepicker({
    inline: true,
    stepping: 15,
    minDate: moment(),
    locale: "pl",
    format: "YYYY-MM-DD HH:mm",
    icons: {
      up: "up-icon ",
      down: "down-icon ",
      previous: "previous-icon",
      next: "next-icon",
    },
  });

  $("#datetimepicker1").on("dp.change", function (event) {
    $("#selected-date").text(event.date);
    var formatted_date = event.date.format("YYYY-MM-DD HH:mm");
    $("#my_hidden_input").val(formatted_date);
    $("#hidden-val").text($("#my_hidden_input").val());
  });

  if ($(".datepicker")[0] != null) {
    let datepicker = document.querySelector(".datepicker");
    let timepicker = document.querySelector(".timepicker");
    const markupDate = `
				<div class="icon__container">
					<span class="icon icon--callendar"></span>
					<span class="datepicker__title"> Wybierz datę </span>
				</div>
			`;
    const markupTime = `
			<div class="icon__container">
				<span class="icon icon--time"></span>
				<span class="datepicker__title"> Wybierz godzinę</span>
			</div>
		`;
    datepicker.insertAdjacentHTML("beforebegin", markupDate);
    timepicker.insertAdjacentHTML("beforebegin", markupTime);
  }
};

export const initSmoothScroll = () => {
  // Select all links with hashes
  $('a[href*="#"]')
    // Remove links that don't actually link to anything
    .not('[href="#"]')
    .not('[href="#0"]')
    .click(function (event) {
      // On-page links
      if ($("body").hasClass("nav-active")) {
        $("body").removeClass("nav-active");
        $(".menu-icon").removeClass("active");
      }
      if (
        location.pathname.replace(/^\//, "") ==
          this.pathname.replace(/^\//, "") &&
        location.hostname == this.hostname
      ) {
        // Figure out element to scroll to
        var target = $(this.hash);
        target = target.length
          ? target
          : $("[name=" + this.hash.slice(1) + "]");
        // Does a scroll target exist?
        if (target.length) {
          // Only prevent default if animation is actually gonna happen
          event.preventDefault();
          $("html, body").animate(
            {
              scrollTop: target.offset().top,
            },
            1000,
            function () {
              // Callback after animation
              // Must change focus!
              var $target = $(target);
              $target.focus();
              if ($target.is(":focus")) {
                // Checking if the target was focused
                return false;
              } else {
                $target.attr("tabindex", "-1"); // Adding tabindex for elements not focusable
                $target.focus(); // Set focus again
              }
            }
          );
        }
      }
    });
};

export const initSearchbarAccordion = () => {
  var searchTerm, panelContainerId;
  // Create a new contains that is case insensitive
  $.expr[":"].containsCaseInsensitive = function (n, i, m) {
    return jQuery(n).text().toUpperCase().indexOf(m[3].toUpperCase()) >= 0;
  };

  $("#accordion_search_bar").on("change keyup paste click", function () {
    searchTerm = $(this).val();
    let filter = $(this).val().toUpperCase();

    $(".accordion__item").addClass("active");
    $(".js-accordion-body").show();
    $(".accordion-body__contents").show();
    $(".accordion-body__title").hide();

    $(".accordion__item").each(function () {
      panelContainerId = "#" + $(this).attr("id");

      let li = $(panelContainerId).find(".accordion-body__contents");
      for (let i = 0; i < li.length; i++) {
        if ($(li[i]).text().toUpperCase().indexOf(filter) > -1) {
          li[i].style.display = "";
        } else {
          li[i].style.display = "none";
        }
      }
      $(
        panelContainerId + ":not(:containsCaseInsensitive(" + searchTerm + "))"
      ).slideUp(500, "easeInOutCirc");
      $(
        panelContainerId + ":containsCaseInsensitive(" + searchTerm + ")"
      ).slideDown(500, "easeInOutCirc");
    });
  });
};
export const checkIfGiftFormIsValidated = () => {
  if ($("#w0").valid()) {
    document.getElementById("w0").submit();
  }
};

export const initVoucherConfigurator = () => {
  $("#w0").validate({
    ignore: [],

    rules: {
      delivery: {
        required: true,
      },
      // productsSummary: {
      //     function(element) {
      //    //     console.log($(element).val())
      //     }
      // }
    },
    messages: {
      delivery: "Wybierz conajmniej jedną metodę",
    },
  });

  function init() {
    document.addEventListener("click", function (e) {
      if (e.target && $(e.target).hasClass("increase")) {
        increase($(e.target));
      } else if (e.target && $(e.target).hasClass("decrease")) {
        decrease($(e.target));
      }
    });
    addEventListeners();
    $("[data-decrease]").on("click", function () {
      decrease($(this));
    });

    $("[data-increase]").on("click", function () {
      increase($(this));
    });

    $("#checkbox-alternative-delivery").change(function () {
      $("#alternative-delivery").toggleClass("visible");
    });

    $("[data-addbox]").click(addNewBox);
    $("[data-value]").change(valueChange, radioChange);

    initTabs();
  }

  function addEventListeners() {
    $(".input__yourprice").on("change", function () {
      $(this).attr("data-price", $(this).val());
      calculatePrice();
    });
  }

  function addNewBox() {
    var numberElement = $(".gift__box").length;
    var wrapper = document.getElementById("gifts");

    const markup = `
        <div class="gift__box">
        <div class="gift__price"><span class="title">Podarunek na kwotę</span>
            <input type="number" id="own-price${numberElement}" class="input input__yourprice" min="50"  name="FormGiftItem[${numberElement}][price]" data-price="0" placeholder="wpisz własną kwotę">
        </div>
       
        <div class="gift__spinners">
        <span class="btn btn__spinner decrease"  data-decrease="">-</span>
            <input type="hidden" id="formgiftitem-${numberElement}-name" name="FormGiftItem[${numberElement}][name]" value="Podarunek na własną kwotę">
            <input type="text" id="formgiftitem-${numberElement}-quantity" name="FormGiftItem[${numberElement}][quantity]" value="0" readonly="" data-value=""> 
         <span class="btn btn__spinner increase" data-increase="">+</span>
        </div>
        </div>`;

    wrapper.insertAdjacentHTML("beforeend", markup);
    addEventListeners();
  }

  function decrease($element) {
    var value = $element.parent().find("[data-value]").val();
    if (value >= 1) {
      value--;
      $element.parent().find("[data-value]").attr("value", value);
      calculatePrice();
    }
  }

  function increase($element) {
    var value = $element.parent().find("[data-value]").val();
    if (value < 100) {
      value++;
      $element.parent().find("[data-value]").attr("value", value);
      calculatePrice();
    }
  }

  function valueChange() {
    var value = $(this).attr("value");

    if (value == undefined || isNaN(value) == true || value <= 0) {
      $(this).attr("value", 1);
      calculatePrice();
    } else if (value >= 100) {
      $(this).attr("value", 99);
      calculatePrice();
    }
  }

  function radioChange() {
    calculatePrice();
  }

  function initTabs() {
    $("ul.tabs li").click(function () {
      var tab_id = $(this).attr("data-tab");
      if (tab_id === "company") {
        $('input[value="transfer"]')
          .prop("disabled", false)
          .prop("checked", false);
        $(".single-input")
          .filter(function () {
            return $(this).data("show") === "company";
          })
          .show();
        $("input[name='FormGift[company]']").rules("add", {
          required: true,
        });
        $("input[name='FormGift[tin]']").rules("add", {
          required: true,
        });
      } else {
        $("input[name='FormGift[company]']").rules("add", {
          required: false,
        });
        $("input[name='FormGift[tin]']").rules("add", {
          required: false,
        });

        $('input[value="transfer"]')
          .prop("disabled", true)
          .prop("checked", false);
        $(".single-input")
          .filter(function () {
            return $(this).data("show") === "company";
          })
          .hide();
      }
      $("ul.tabs li").removeClass("current");
      $(".tab-content").removeClass("current");
      $(this).addClass("current");
    });
  }

  function calculatePrice() {
    let results = 0;
    let delivery = 0;
    delivery = parseFloat(
      $("input[name=delivery]:checked").attr("data-delivery-price")
    );
    $(".gift__box").each(function () {
      let currentRate = parseFloat(
        $(this).find("[data-price]").attr("data-price")
      );
      let currentCount = parseFloat($(this).find("input[data-value]").val());
      results += currentCount * currentRate;
    });
    updateFields(results, delivery);
  }

  function updateFields(giftPrice, deliveryPrice) {
    let summary = 0;
    summary = Number.isNaN(deliveryPrice)
      ? giftPrice
      : giftPrice + deliveryPrice;
    summary = summary.toFixed(2);
    $("#product-result").text(giftPrice + " ZŁ");
    $("#productsSummary").attr("value", giftPrice);

    if (!Number.isNaN(deliveryPrice)) {
      $("#delivery-result").text(deliveryPrice + " ZŁ");
      $("#deliverySummary").attr("value", deliveryPrice);
    }
    $("#summary").attr("value", summary);
    $(".reservation__results--price").text(summary + " ZŁ");
  }

  init();
};
